<script lang="ts">
import {defineComponent} from 'vue'
import Card from "primevue/card";
import {useAuthStore} from "@/stores/auth.store"
import {useThemeStore} from "@/stores/theme.store"
import Button from "primevue/button"
import CourseRegistrationModal from "@/components/Admin/AdministrationModal/CourseRegistrationModal.vue"
import generateStudentsWithValidInsurancePdf from "@/services/admin/file_generators/studentsWithValidInsurance"
import PanelMenu from "primevue/panelmenu"
import {Keyable} from "@/types/keyable.type";


export default defineComponent({
  name: "LeftMenu",
  components: {
    CourseRegistrationModal,
    Card,
    Button,
    PanelMenu
  },
  computed: {
    window() {
      return window
    }
  },
  watch:{
    '$route': 'showCurrentRoute',
    "expandedKeys": function () {
      if(!this.expandedKeys['rapid_actions']){
        this.expandedKeys['rapid_actions'] = true
      }else if(this.expandedKeys['rapid_actions'] === undefined) {
        this.expandedKeys['rapid_actions'] = true
      }
    }
  },
  data() {
    return {
      expandedKeys: {'rapid_actions': true} as Record<string, boolean>,
      authStore: useAuthStore(),
      themeStore: useThemeStore(),
      items: [
        {
          key: 'dashboard',
          label: this.$t('admin_components.left_menu.dashboard_label'),
          icon: 'pi pi-fw fa-solid fa-tachometer-alt',
          expandable: true,
          route: {name: 'admin_dashboard'}
        },
        {
          key: 'rapid_actions',
          label: this.$t('admin_components.left_menu.rapid_actions.label'),
          icon: 'pi pi-fw pi-thumbtack',
          expandable: false,
          items: [
            {label: this.$t('admin_components.left_menu.rapid_actions.sub_items.register_student_label'), icon: 'pi pi-fw fa-solid fa-school', command: this.showCourseRegistrationModal},
            {label: this.$t('admin_components.left_menu.rapid_actions.sub_items.get_insurance_pdf_label'), icon: 'pi pi-fw fa-solid fa-file-pdf', command: generateStudentsWithValidInsurancePdf},
          ]
        },
        {
          key: 'events',
          label: this.$t('admin_components.left_menu.events.label'),
          icon: 'pi pi-fw pi-calendar',
          expandable: true,
          items: [
            {label: this.$t('admin_components.left_menu.events.sub_items.course_label'), icon: 'pi pi-fw fa-solid fa-calendar-day', route: {name: 'admin_course_list'}},
            {label: this.$t('admin_components.left_menu.events.sub_items.lesson_schedule_label'), icon: 'pi pi-fw fa-regular fa-calendar-check', route: {name: 'admin_lesson_schedule'}},
            {label: this.$t('admin_components.left_menu.events.sub_items.gala_label'), icon: 'pi pi-fw fa-solid fa-calendar-xmark', route: {name: 'admin_gala_list'}},
            {label: this.$t('admin_components.left_menu.events.sub_items.workshop_label'), icon: 'pi pi-fw fa-solid fa-calendar-week', route: {name: 'admin_workshop_list'}},
            //{label: this.$t('admin_components.left_menu.events.sub_items.workshop_day_label'), icon: 'pi pi-fw fa-solid fa-calendar-days', route: {name: 'admin_workshop_day_list'}},
          ]
        },
        {
          key: 'peoples',
          label: this.$t('admin_components.left_menu.peoples.label'),
          icon: 'pi pi-fw pi-users',
          expandable: true,
          items: [
            {label: this.$t('admin_components.left_menu.peoples.sub_items.student_label'), icon: 'pi pi-fw fa-solid fa-user-graduate', route: {name: 'admin_student_list'}},
            {label: this.$t('admin_components.left_menu.peoples.sub_items.teacher_label'), icon: 'pi pi-fw fa-solid fa-chalkboard-user', route: {name: 'admin_teacher_list'}},
            {label: this.$t('admin_components.left_menu.peoples.sub_items.contact_person_label'), icon: 'pi pi-fw fa-solid fa-address-book', route: {name: 'admin_contact_person_list'}},
            {label: this.$t('admin_components.left_menu.peoples.sub_items.admin_label'), icon: 'pi pi-fw fa-solid fa-user-tie', route: {name: 'admin_admin_list'}},
          ]
        },
        {
          key: 'administration',
          label: this.$t('admin_components.left_menu.administration.label'),
          icon: 'pi pi-fw pi-file',
          expandable: true,
          items: [
            {label: this.$t('admin_components.left_menu.administration.sub_items.card_label'), icon: 'pi pi-fw fa-solid fa-ticket', route: {name: 'admin_card_list'}},
            {label: this.$t('admin_components.left_menu.administration.sub_items.card_type_label'), icon: 'pi pi-fw fa-solid fa-ticket-simple', route: {name: 'admin_card_type_list'}},
            {label: this.$t('admin_components.left_menu.administration.sub_items.medical_certificate_label'), icon: 'pi pi-fw fa-solid fa-file-medical', route: {name: 'admin_medical_certificate_list'}},
            {label: this.$t('admin_components.left_menu.administration.sub_items.insurance_label'), icon: 'pi pi-fw fa-solid fa-file', route: {name: 'admin_insurance_list'}},
            {label: this.$t('admin_components.left_menu.administration.sub_items.holidays_label'), icon: 'pi pi-fw fa-solid fa-umbrella-beach', route: {name: 'admin_holidays_list'}},
            {label: this.$t('admin_components.left_menu.administration.sub_items.clothing_size_label'), icon: 'pi pi-fw fa-solid fa-shirt', route: {name: 'admin_clothing_size_list'}},
            {label: this.$t('admin_components.left_menu.administration.sub_items.payment_label'), icon: 'pi pi-fw fa-solid fa-euro-sign', route: {name: 'admin_payment_list'}},
            {label: this.$t('registration_fee_credit.title'), icon: 'pi pi-fw fa-solid fa-receipt', route: {name: 'admin_registration_fee_credit_list'}},
          ]
        },
        {
          key: 'reports',
          label: this.$t('admin_components.left_menu.reports.label'),
          icon: 'pi pi-fw pi-chart-line',
          expandable: true,
          items: [
            {label: this.$t('admin_components.left_menu.reports.sub_items.teacher_hours_label'), icon: 'pi pi-fw fa-solid fa-clock', route: {name: 'admin_report_teacher_hours'}},
            {label: this.$t('admin_components.left_menu.reports.sub_items.teacher_courses_label'), icon: 'pi pi-fw fa-solid fa-chalkboard-user', route: {name: 'admin_report_teacher_courses'}},
            {label: this.$t('admin_components.left_menu.reports.sub_items.student_courses_label'), icon: 'pi pi-fw fa-solid fa-user-graduate', route: {name: 'admin_report_student_courses'}},
            {label: this.$t('admin_components.left_menu.reports.sub_items.gala_registrations_label'), icon: 'pi pi-fw fa-solid fa-masks-theater', route: {name: 'admin_report_gala_registrations'}},
            {label: this.$t('admin_components.left_menu.reports.sub_items.insurance_label'), icon: 'pi pi-fw fa-solid fa-shield-heart', route: {name: 'admin_report_insurance'}},
            // {label: this.$t('admin_components.left_menu.reports.sub_items.course_registrations_label'), icon: 'pi pi-fw fa-solid fa-list', route: {name: 'admin_report_course_registrations'}},
          ]
        },
        {
          key: 'settings',
          label: this.$t('admin_components.left_menu.settings_label'),
          icon: 'pi pi-fw fa-solid fa-cog',
          expandable: true,
          route: {name: 'admin_settings'}
        },
      ],
      logoDark: process.env.VUE_APP_LOGO_DARK,
      logoLight: process.env.VUE_APP_LOGO_LIGHT,
    }
  },
  methods: {
    showCourseRegistrationModal() {
      const courseRegistrationModal = this.$refs.courseRegistrationModal as typeof CourseRegistrationModal
      courseRegistrationModal.open()
    },
    updateExpandedKeys(value: any) {
      localStorage.setItem('leftMenuExpandedKeys', JSON.stringify(value))
    },
    showCurrentRoute() {
      const routeMaps: Keyable  = {
        'admin_dashboard': 'dashboard',
        'admin_course': 'events',
        'admin_lesson': 'events',
        'admin_gala': 'events',
        'admin_workshop': 'events',
        'admin_workshop_day': 'events',
        'admin_student': 'peoples',
        'admin_teacher': 'peoples',
        'admin_contact_person': 'peoples',
        'admin_admin': 'peoples',
        'admin_card': 'administration',
        'admin_card_type': 'administration',
        'admin_medical_certificate': 'administration',
        'admin_insurance': 'administration',
        'admin_holidays': 'administration',
        'admin_registration': 'administration',
        'admin_report': 'reports',
      }

      if(!this.$router.currentRoute.value.name) return
      const currentRouteSplitted: string[] = this.$router.currentRoute.value.name.toString().split('_')
      const currentRoute: string = currentRouteSplitted[0]+"_"+currentRouteSplitted[1]
      if(routeMaps[currentRoute]){
        this.expandedKeys[routeMaps[currentRoute].toString()] = true
      }
    },
  },
  mounted() {
    const expandedKeys = localStorage.getItem('leftMenuExpandedKeys')
    if(expandedKeys){
      this.expandedKeys = JSON.parse(expandedKeys)
    }
    this.showCurrentRoute()
  }
})
</script>

<template>
    <Card :class="'menu_container' + (window.innerWidth > 750 ? ' show' : '')">
      <template #content>
        <CourseRegistrationModal ref="courseRegistrationModal"/>
        <PanelMenu :model="items" class="panel_menu" multiple v-model:expandedKeys="expandedKeys"
                   @update:expandedKeys="updateExpandedKeys">
          <template #item="{ item, props }">
            <RouterLink v-if="item.route" v-slot="{ href, navigate, isActive }" :to="item.route" custom>
              <a :href="href" v-bind="props.action" @click="navigate" :class="isActive ? 'menu_item router-active': 'menu_item' " aria-hidden="false">
                <span :class="item.icon+' p-menu-item-icon'" />
                <span class="label" :style="item.items ? 'font-weight: bold': ''">{{ item.label }}</span>
                <span v-if="item.items && item.expandable && !expandedKeys[item.key]" class="pi pi-angle-down" />
                <span v-if="item.items && item.expandable && expandedKeys[item.key]" class="pi pi-angle-up" />
              </a>
            </RouterLink>
            <a v-else :href="item.url" :target="item.target" v-bind="props.action" class="menu_item" aria-hidden="false">
              <span :class="item.icon+' p-menu-item-icon'" />
              <span class="label" :style="item.items ? 'font-weight: bold': ''">{{ item.label }}</span>
              <span v-if="item.items && item.expandable && !expandedKeys[item.key]" class="pi pi-angle-down" />
              <span v-if="item.items && item.expandable && expandedKeys[item.key]" class="pi pi-angle-up" />
            </a>
          </template>
        </PanelMenu>
      </template>
      <template #footer>
        <div class="menu_footer">
          <Button :icon="themeStore.getTheme === 'dark' ? 'pi pi-sun': 'pi pi-moon'" severity="contrast" @click="themeStore.toggleTheme()"/>
          <Button v-if="authStore.isLoggedIn" icon="pi pi-sign-out" @click="authStore.logout" :fluid="true" severity="danger"/>
        </div>
      </template>
    </Card>
</template>

<style scoped lang="scss">
.menu_container :deep(){
  .p-panelmenu{
    gap: 0;
  }
  .p-panelmenu-panel{
    border: 0;
    background: transparent;
    .p-panelmenu-submenu{
      padding-left: .5rem;
    }
  }
  .p-card-body{
    padding: 0;
    .p-card-footer{
      border-top: 1px solid var(--p-content-border-color)
    }
  }
}
.panel_menu{
  padding: 0.5rem;
}
.menu_item{
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: .2rem;
  padding: .5rem;
  text-decoration: none;
  color: var(--p-panelmenu-item-color);
  .label{
    margin-left: .5rem;
  }
  .pi-angle-down, .pi-angle-up{
    margin-left: auto;
  }
}
.menu_footer{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  text-align: left;
  display: flex;
  border-top: 1px solid var(--p-menu-border-color);
  gap: 1rem;
  justify-content: center;
}
.router-active{
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: var(--p-panelmenu-item-border-radius);
}
.theme-dark{
  .router-active{
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: var(--p-panelmenu-item-border-radius);
  }
}
</style>
